module.exports = {
    REPORT_FREQUENCY: Object.freeze({
        MONTH_ONCE: 1,
        MONTH_TWICE: 2,
        WEEK_ONCE: 3,
        DAY_ONCE: 4
    }),
    REPORT_FREQUENCY_TITLE: Object.freeze({
        1: 'Один раз в месяц (1 числа)',
        2: 'Два раза в месяц (1 и 16 числа)',
        3: 'Один раз в неделю (каждый понедельник)',
        4: 'Один раз в день (в 9:00)',
    }),
}
